import axios from '../../plugins/axios.js';

export default {
    async saveSupportDetails(supportData) {
        return await axios.post('api/Support/SendSupportEmail', supportData);
    }
};